/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatDataset } from './SingleTurnChatDataset';
import {
  SingleTurnChatDatasetFromJSON,
  SingleTurnChatDatasetFromJSONTyped,
  SingleTurnChatDatasetToJSON,
} from './SingleTurnChatDataset';

/**
 *
 * @export
 * @interface PaginatedSingleTurnChatDatasetList
 */
export interface PaginatedSingleTurnChatDatasetList {
  /**
   *
   * @type {number}
   * @memberof PaginatedSingleTurnChatDatasetList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedSingleTurnChatDatasetList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedSingleTurnChatDatasetList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<SingleTurnChatDataset>}
   * @memberof PaginatedSingleTurnChatDatasetList
   */
  results: Array<SingleTurnChatDataset>;
}

/**
 * Check if a given object implements the PaginatedSingleTurnChatDatasetList interface.
 */
export function instanceOfPaginatedSingleTurnChatDatasetList(
  value: object,
): value is PaginatedSingleTurnChatDatasetList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedSingleTurnChatDatasetListFromJSON(json: any): PaginatedSingleTurnChatDatasetList {
  return PaginatedSingleTurnChatDatasetListFromJSONTyped(json, false);
}

export function PaginatedSingleTurnChatDatasetListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedSingleTurnChatDatasetList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(SingleTurnChatDatasetFromJSON),
  };
}

export function PaginatedSingleTurnChatDatasetListToJSON(value?: PaginatedSingleTurnChatDatasetList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(SingleTurnChatDatasetToJSON),
  };
}
